import { useEffect, useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';

import MainContent from './components/mainContent/MainContent';

import { Loader } from '@/components';
import { Layout, MainHome } from '@/components/GenericsTournaments';
import { useMetaData } from '@/hooks/useMetaData';
import useToast from '@/hooks/useToast';
import useTourney from '@/hooks/useTourney';
import ROUTES from '@/router/routes';
import { getInfoUsuarioOro } from '@/services/goldDate';
import { EnumContextGDT } from '@/types/team';
import { formatNumberToLocale } from '@/utils';
import { SECTION_NAME_FOR_ADS } from '@/utils/ads';

export const GoldDateHome = () => {
  const { updateTourney } = useTourney();
  const toast = useToast();
  const navigate = useNavigate();
  const [mounted, setMounted] = useState(false);
  useMetaData({
    title: 'Fecha de Oro',
  });

  const { data, isLoading, refetch } = useQuery(
    'infoUsuarioOro',
    async () => await getInfoUsuarioOro(),
    {
      refetchOnWindowFocus: false,
      retry: false,
      keepPreviousData: false,
      onSuccess: (data) => {
        if (!data.estado) {
          if ('codError' in data && 'mensaje' in data) {
            toast.show(data.mensaje as string);
          }
        }
      },
      onError: (error) => {
        const err = error as Error;
        toast.show(err.message);
      },
    }
  );

  useEffect(() => {
    if (data?.estado && !isLoading) {
      updateTourney({
        tourneyPrice: data.premio,
        tourneyPinPrice: data.precioDeListaPin,
      });
      if (
        data.estaPublicado &&
        !data.inscripcionPosible &&
        ((data.actualesSinPublicar && data.actualesSinPublicar.length > 0) ||
          (data.todosLosPublicados && data.todosLosPublicados.length > 0)) &&
        !data.estaInactiva
      ) {
        // muestro el listado de participando -presente o pasado
        setMounted(false);
        navigate(ROUTES.goldDate.list, { state: true });
      } else {
        setMounted(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading]);

  // TODO: fix para salida.. revisar al seguir el torneo
  const subtitle = useMemo(() => {
    return `Participan sólo 20 DT's ¡El ganador se lleva $${formatNumberToLocale(
      data?.premio ?? 0
    )} en efectivo!`;
  }, [data?.premio]);

  return (
    <>
      <Loader isVisible={isLoading && !mounted} timeout={isLoading} />
      <Layout
        adsSections={SECTION_NAME_FOR_ADS.fechadeoro}
        className="p-4"
        main={() => {
          return (
            mounted && (
              <MainHome
                className="w-full"
                context={EnumContextGDT.GoldDate}
                subtitle={subtitle}
                title={'Fecha de Oro'}
              >
                <MainContent dataInitUsuarioOro={data} refetch={refetch} />
              </MainHome>
            )
          );
        }}
        mobile={{
          leftContent: {
            showMenuAction: true,
            items: true,
          },
          centerContent: { title: 'Fecha de Oro' },
        }}
        trackProps={{
          fechaOro:
            data?.participaActual || Boolean(data?.todosLosPublicados?.length),
        }}
        withBanners={true}
      />
    </>
  );
};
